
import React from 'react';

const commercialReviews = [
  {
    id: 1,
    name: "Marcus Johnson",
    title: "Property Manager",
    company: "Sunrise Plaza Shopping Center",
    location: "Las Vegas, NV",
    date: "November 2024",
    rating: 5,
    text: "RW Construction handled the complete parking lot renovation for our shopping center. The paver installation was done efficiently with minimal disruption to our tenants. Outstanding professionalism and quality work.",
    projectType: "Parking Lot Renovation",
    avatar: "M",
    image: "https://public.readdy.ai/ai/img_res/9069e052533da7f3dc268d91125613ae.jpg"
  },
  {
    id: 2,
    name: "Patricia Chen",
    title: "Restaurant Owner",
    company: "Golden Dragon Restaurant",
    location: "Henderson, NV",
    date: "October 2024",
    rating: 5,
    text: "They transformed our outdoor dining patio beautifully. The cool deck coating and synthetic grass areas look amazing. Our customers love the new space and it has increased our seating capacity significantly.",
    projectType: "Outdoor Patio",
    avatar: "P",
    image: "https://readdy.ai/api/search-image?query=Beautiful%20restaurant%20outdoor%20patio%20with%20elegant%20pavers%20and%20synthetic%20grass%2C%20outdoor%20dining%20area%20with%20string%20lights%2C%20commercial%20restaurant%20exterior%2C%20professional%20photography&width=600&height=400&seq=commercial-review-002&orientation=landscape"
  },
  {
    id: 3,
    name: "Robert Martinez",
    title: "HOA President",
    company: "Desert Springs Community",
    location: "Summerlin, NV",
    date: "September 2024",
    rating: 5,
    text: "RW Construction renovated our entire community pool area and common spaces. The project was completed on time and within budget. The residents are thrilled with the results. Highly recommend for HOA projects.",
    projectType: "Community Pool & Common Areas",
    avatar: "R",
    image: "https://readdy.ai/api/search-image?query=Luxurious%20community%20pool%20area%20with%20fresh%20pool%20deck%2C%20lounge%20chairs%2C%20palm%20trees%2C%20HOA%20common%20area%20renovation%2C%20Las%20Vegas%20residential%20community%2C%20professional%20real%20estate%20photography&width=600&height=400&seq=commercial-review-003&orientation=landscape"
  },
  {
    id: 4,
    name: "Jennifer Williams",
    title: "General Manager",
    company: "Oasis Hotel & Suites",
    location: "Las Vegas Strip, NV",
    date: "August 2024",
    rating: 5,
    text: "The pool deck resurfacing and landscaping renovation exceeded our expectations. They worked around our busy schedule and completed the project without disturbing our guests. True professionals.",
    projectType: "Hotel Pool Renovation",
    avatar: "J",
    image: "https://readdy.ai/api/search-image?query=Stunning%20hotel%20pool%20area%20with%20modern%20pool%20deck%2C%20luxury%20resort%20style%20landscaping%2C%20palm%20trees%2C%20Las%20Vegas%20hotel%20exterior%20renovation%2C%20professional%20hospitality%20photography&width=600&height=400&seq=commercial-review-004&orientation=landscape"
  },
  {
    id: 5,
    name: "David Thompson",
    title: "Facility Director",
    company: "Valley Medical Center",
    location: "North Las Vegas, NV",
    date: "July 2024",
    rating: 5,
    text: "Professional, efficient, and detail-oriented. They renovated our entrance walkways and patient garden areas. The team was respectful of our healthcare environment and maintained cleanliness throughout.",
    projectType: "Medical Facility Grounds",
    avatar: "D",
    image: "https://readdy.ai/api/search-image?query=Modern%20medical%20center%20exterior%20with%20elegant%20paver%20walkways%2C%20healing%20garden%20area%2C%20professional%20landscaping%2C%20healthcare%20facility%20entrance%2C%20clean%20professional%20photography&width=600&height=400&seq=commercial-review-005&orientation=landscape"
  },
  {
    id: 6,
    name: "Angela Foster",
    title: "Owner",
    company: "Desert Auto Dealership",
    location: "Enterprise, NV",
    date: "June 2024",
    rating: 5,
    text: "Our showroom exterior and customer parking area look incredible now. The paver work and landscaping have significantly improved our curb appeal. We have received so many compliments from customers.",
    projectType: "Dealership Exterior",
    avatar: "A",
    image: "https://readdy.ai/api/search-image?query=Modern%20car%20dealership%20exterior%20with%20elegant%20paver%20parking%20lot%2C%20professional%20landscaping%2C%20commercial%20property%20curb%20appeal%2C%20Las%20Vegas%20auto%20dealership%2C%20professional%20photography&width=600&height=400&seq=commercial-review-006&orientation=landscape"
  }
];

export function CommercialReviews() {
  return (
    <section className="py-20 bg-[#2C2C2C]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-3">
            <div className="w-2 h-2 bg-[#FF6B35] rounded-full"></div>
            <span className="text-[#FF6B35] text-sm font-semibold tracking-wider uppercase">Commercial Reviews</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Trusted by Las Vegas<br />Businesses
          </h2>
          <p className="text-gray-400 text-base max-w-2xl mx-auto">
            See why property managers, business owners, and HOAs choose RW Construction for their commercial projects
          </p>
          
          {/* Commercial Stats */}
          <div className="flex flex-wrap items-center justify-center gap-8 mt-8">
            <div className="text-center">
              <div className="text-3xl font-bold text-[#FF6B35]">400+</div>
              <div className="text-sm text-gray-400">Commercial Projects</div>
            </div>
            <div className="w-px h-12 bg-gray-700 hidden sm:block"></div>
            <div className="text-center">
              <div className="text-3xl font-bold text-[#FF6B35]">4.9</div>
              <div className="text-sm text-gray-400">Average Rating</div>
            </div>
            <div className="w-px h-12 bg-gray-700 hidden sm:block"></div>
            <div className="text-center">
              <div className="text-3xl font-bold text-[#FF6B35]">20+</div>
              <div className="text-sm text-gray-400">Years Experience</div>
            </div>
            <div className="w-px h-12 bg-gray-700 hidden sm:block"></div>
            <div className="text-center">
              <div className="text-3xl font-bold text-[#FF6B35]">100%</div>
              <div className="text-sm text-gray-400">Client Satisfaction</div>
            </div>
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {commercialReviews.map((review) => (
            <div 
              key={review.id}
              className="bg-[#3A3A3A] rounded-2xl overflow-hidden hover:bg-[#444444] transition-all duration-300 group"
            >
              {/* Project Image */}
              <div className="relative h-48 w-full overflow-hidden">
                <img 
                  src={review.image}
                  alt={`${review.projectType} - ${review.company}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 bg-[#FF6B35] text-white px-3 py-1 rounded-full">
                  <span className="text-xs font-semibold">{review.projectType}</span>
                </div>
                <div className="absolute top-3 right-3 bg-white/95 backdrop-blur-sm px-3 py-1 rounded-full flex items-center gap-1.5">
                  <i className="ri-map-pin-2-fill text-[#FF6B35] text-sm"></i>
                  <span className="text-xs font-medium text-[#2C2C2C]">{review.location}</span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                {/* Rating & Date */}
                <div className="flex items-center justify-between mb-3">
                  <div className="flex gap-0.5">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i 
                        key={star} 
                        className={`ri-star-fill text-base ${star <= review.rating ? 'text-[#FBBC05]' : 'text-gray-600'}`}
                      ></i>
                    ))}
                  </div>
                  <span className="text-xs text-gray-500">{review.date}</span>
                </div>

                {/* Review Text */}
                <p className="text-gray-300 text-sm leading-relaxed mb-5 line-clamp-4">"{review.text}"</p>

                {/* Reviewer Info */}
                <div className="flex items-center gap-3 pt-4 border-t border-gray-600">
                  <div className="w-12 h-12 rounded-full bg-[#FF6B35] flex items-center justify-center text-white font-bold text-lg">
                    {review.avatar}
                  </div>
                  <div className="flex-1">
                    <div className="font-semibold text-white text-sm">{review.name}</div>
                    <div className="text-gray-400 text-xs">{review.title}</div>
                    <div className="text-[#FF6B35] text-xs font-medium">{review.company}</div>
                  </div>
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-building-2-line text-gray-500 text-xl"></i>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <p className="text-gray-400 mb-6">Ready to transform your commercial property?</p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <a
              href="tel:7025001790"
              className="inline-flex items-center gap-2 bg-[#FF6B35] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#E55A2B] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill text-lg"></i>
              Call 702-500-1790
            </a>
            <a
              href="#contact"
              className="inline-flex items-center gap-2 bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-[#2C2C2C] transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-file-list-3-line text-lg"></i>
              Request Commercial Quote
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
